export const naFormatter = (value) => {
  if(value === undefined || value === null || value === 0)
    return 'NA';
  else
    return value;
}
export const emptyFormatter = (value) => {
  if(value === undefined || value === null || value === 0)
    return '-';
  else
    return value;
}